module.exports = __webpack_public_path__ + "static/media/healthtech50.f2a8fa56.webp";